import { CarouselCardMobile  as CarouselCardMobileComponent } from "./CarouselCardMobile.component";

export type { IOpen } from "./CarouselCardMobile.types";

export const CarouselCardMobile = CarouselCardMobileComponent;
